/**
 * A collection of shader materials that are used in the post processing passes.
 *
 * @module postprocessing/materials
 */

export { AdaptiveLuminosityMaterial } from "./AdaptiveLuminosityMaterial.js";
export { BokehMaterial } from "./BokehMaterial.js";
export { ColorEdgesMaterial } from "./ColorEdgesMaterial.js";
export { CombineMaterial } from "./CombineMaterial.js";
export { ConvolutionMaterial, KernelSize } from "./ConvolutionMaterial.js";
export { CopyMaterial } from "./CopyMaterial.js";
export { DepthComparisonMaterial } from "./DepthComparisonMaterial.js";
export { DotScreenMaterial } from "./DotScreenMaterial.js";
export { FilmMaterial } from "./FilmMaterial.js";
export { GlitchMaterial } from "./GlitchMaterial.js";
export { GodRaysMaterial } from "./GodRaysMaterial.js";
export { LuminosityMaterial } from "./LuminosityMaterial.js";
export { OutlineBlendMaterial } from "./OutlineBlendMaterial.js";
export { OutlineEdgesMaterial } from "./OutlineEdgesMaterial.js";
export { PixelationMaterial } from "./PixelationMaterial.js";
export { RealisticBokehMaterial } from "./RealisticBokehMaterial.js";
export { ShockWaveMaterial } from "./ShockWaveMaterial.js";
export { SMAABlendMaterial } from "./SMAABlendMaterial.js";
export { SMAAWeightsMaterial } from "./SMAAWeightsMaterial.js";
export { ToneMappingMaterial } from "./ToneMappingMaterial.js";



//////////////////
// WEBPACK FOOTER
// ./~/postprocessing/src/materials/index.js
// module id = 2
// module chunks = 0